import React from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import { PageSeo } from '../seo/PageSeo';
import { breadcrumbSchema } from '../seo/schemas';
import { findIntegration } from './integrations';
import { Footer } from '../homepage/Footer';
import '../pages/static-page.css';

export const IntegrationDetailPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  if (!slug) return <Navigate to="/integrations" replace />;
  const integration = findIntegration(slug);
  if (!integration) return <Navigate to="/integrations" replace />;
  const fm = integration.module.frontmatter;
  const Content = integration.module.default;

  return (
    <>
      <PageSeo
        path={`/integrations/${slug}`}
        titleKey={fm.title}
        descriptionKey={fm.description}
        ogImage={fm.ogImage || '/og/og-default.png'}
        jsonLd={[
          breadcrumbSchema([
            { name: 'Home', path: '/' },
            { name: 'Integrations', path: '/integrations' },
            { name: fm.framework, path: `/integrations/${slug}` },
          ]),
        ]}
      />
      <article className="page-wrapper">
        <div className="static-page" style={{ paddingTop: '40px' }}>
          <nav style={{ fontSize: 14, color: '#666', marginBottom: 16 }}>
            <Link to="/integrations" style={{ color: '#2563EB', textDecoration: 'none' }}>
              ← All integrations
            </Link>
          </nav>
          <h1>{fm.title}</h1>
          <Content />
        </div>
        <Footer />
      </article>
    </>
  );
};
